const rateDimensions = ['category', 'country', 'currency'];
const referenceId = value => String(value?._id || value);
export const costingRateKey = rule => rateDimensions.map(key => referenceId(rule[key])).join(':');

export const buildCostingRateRules = (selections, rules = [], defaultRate = '') => {
  const rates = new Map((rules || []).map(rule => [costingRateKey(rule), rule.rate]));
  const ids = key => (Array.isArray(selections[key]) ? selections[key] : selections[key] ? [selections[key]] : []).map(referenceId);
  return ids('category').flatMap(category => ids('country').flatMap(country => ids('currency').map(currency => {
    const rule = { category, country, currency };
    return { ...rule, rate: rates.get(costingRateKey(rule)) ?? defaultRate };
  })));
};

export const gatewayRateDirections = [
  { key: 'rate', fixedKey: 'in_fixed_rate', label: 'In' },
  { key: 'out_rate', fixedKey: 'out_fixed_rate', label: 'Out' }
];
export const gatewayRateInputs = gatewayRateDirections.flatMap(direction => [
  { key: direction.key, direction: direction.label, label: `${direction.label} Percentage (%)`, max: 100 },
  { key: direction.fixedKey, direction: direction.label, label: `${direction.label} Fixed` }
]);

export const formatGatewayRate = (rule, direction, currency = '') => {
  if (rule?.[direction.key] == null) return '—';
  const fixed = Number(rule[direction.fixedKey] ?? 0);
  return `${rule[direction.key]}%${fixed ? ` + ${fixed}${currency ? ` ${currency}` : ''}` : ''}`;
};

export const formatGatewayMargin = (selling, costing, direction, currency = '') => {
  const sellingRate = selling?.[direction.key];
  if (costing?.[direction.key] == null || sellingRate === '' || sellingRate == null || !Number.isFinite(Number(sellingRate))) return '—';
  const margin = Number(sellingRate) - Number(costing[direction.key]);
  const fixed = Number(selling[direction.fixedKey] ?? 0) - Number(costing[direction.fixedKey] ?? 0);
  return `${margin > 0 ? '+' : ''}${margin.toFixed(2)}%${fixed ? ` ${fixed > 0 ? '+' : '−'} ${Math.abs(fixed)}${currency ? ` ${currency}` : ''}` : ''}`;
};

export const buildGatewayRateRules = (selections, rules = [], defaultRate = '') => {
  const saved = new Map((rules || []).map(rule => [costingRateKey(rule), rule]));
  return buildCostingRateRules(selections, rules, defaultRate).map(rule => {
    const previous = saved.get(costingRateKey(rule));
    return { ...rule, out_rate: previous?.out_rate ?? previous?.rate ?? defaultRate,
      in_fixed_rate: previous?.in_fixed_rate ?? 0, out_fixed_rate: previous?.out_fixed_rate ?? 0 };
  });
};

export const buildPaymentGatewayPayload = (form, { isMaster, canViewFinancial, canEditFinancial }) => {
  const data = { description: form.description, is_active: form.is_active };
  if (isMaster) {
    for (const field of ['provider_id', 'source']) data[field] = form[field];
  } else {
    data.code = form.code;
    data.name = form.name;
  }
  if (isMaster) {
    for (const field of ['category', 'country', 'currency']) data[field] = form[field];
    if (canViewFinancial && canEditFinancial) data.costing_rate_rules = form.costing_rate_rules;
  }
  if (isMaster) {
    data.group_links = form.group_links;
    data.documents = form.documents;
  }
  return data;
};

export const buildMerchantPaymentGatewayPayload = (item, { canViewFinancial, canEditFinancial }) => ({
  provider_id: item.provider_id?._id || item.provider_id,
  ...(canViewFinancial && canEditFinancial ? {
    selling_rate_rules: buildGatewayRateRules(item.provider_id || {}, item.selling_rate_rules, item.selling_rate ?? 0),
    is_client_line: !!item.is_client_line
  } : {}),
  status: item.status,
  group_links: item.group_links || [],
  description: item.description ?? '',
  documents: item.documents || [],
  credentials: item.credentials
});
